// Slide 2 - Overview (moved from SlideOverview)
export default function Slide2() {
  return (
    <div className="w-full max-w-[1200px] relative z-10 px-3 sm:px-4 md:px-6">
      <div className="absolute -right-20 -top-12 hidden md:block">
        <div
          className="accent-blob"
          style={{
            background:
              "linear-gradient(135deg, rgba(99,102,241,0.36), rgba(16,185,129,0.22))",
          }}
        />
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 sm:gap-8 md:gap-12 items-center">
        {/* Left: Heading + intro */}
        <div className="space-y-3 sm:space-y-4 md:space-y-6 text-left">
          <span className="inline-block px-2 sm:px-3 md:px-4 py-1 sm:py-1.5 md:py-2 bg-white/10 backdrop-blur-md rounded-full text-white text-[9px] sm:text-[10px] md:text-xs uppercase tracking-widest font-bold border border-white/20">
            Our Expertise
          </span>

          <h2
            className="text-white font-extrabold leading-tight title-gradient"
            style={{
              fontSize: "clamp(28px, 9vw, 64px)",
              letterSpacing: "-0.02em",
            }}
          >
            Websites & Product Development
          </h2>

          <p
            className="text-white/85 max-w-xl"
            style={{ fontSize: "clamp(14px, 3vw, 20px)", lineHeight: 1.5 }}
          >
            We deliver <span className="keyword">end-to-end solutions</span> —{" "}
            <span className="keyword">elegantly designed websites</span> and
            <span className="keyword"> robust products</span> engineered for{" "}
            <span className="keyword">scale</span>. From{" "}
            <span className="keyword">discovery</span> and UX to
            <span className="keyword"> engineering</span> and launch, our teams
            ship reliable digital experiences tailored to your goals.
          </p>

          <div className="flex flex-wrap gap-2 sm:gap-3 mt-2 sm:mt-3 md:mt-4">
            <div className="inline-flex items-center gap-1.5 sm:gap-2 md:gap-3 bg-white/6 px-2 sm:px-3 md:px-4 py-1 sm:py-1.5 md:py-2 rounded-full border border-white/10 text-white/90 shadow-sm">
              <svg
                width="14"
                height="14"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="opacity-90 sm:w-4 sm:h-4 md:w-5 md:h-5"
              >
                <path
                  d="M3 12h18"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M3 6h18"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  opacity="0.6"
                />
              </svg>
              <span className="keyword text-xs sm:text-sm md:text-base">Discovery & Design</span>
            </div>

            <div className="inline-flex items-center gap-1.5 sm:gap-2 md:gap-3 bg-white/6 px-2 sm:px-3 md:px-4 py-1 sm:py-1.5 md:py-2 rounded-full border border-white/10 text-white/90 shadow-sm">
              <svg
                width="14"
                height="14"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="sm:w-4 sm:h-4 md:w-5 md:h-5"
              >
                <path
                  d="M12 3v18"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M3 12h18"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  opacity="0.6"
                />
              </svg>
              <span className="keyword text-xs sm:text-sm md:text-base">Engineering & Scale</span>
            </div>
          </div>
        </div>

        {/* Right: Two polished cards with heading */}
        <div>
          <h2 className="text-white/90 past-title mb-2 sm:mb-3 title-gradient text-sm sm:text-base md:text-lg">
            Our Past Projects
          </h2>
          <div className="h-0.5 sm:h-1 w-16 sm:w-28 rounded-full bg-gradient-to-r from-indigo-400 via-indigo-300 to-emerald-300 mb-3 sm:mb-4 md:mb-6 opacity-90" />
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4 md:gap-6">
            <div className="card-accent backdrop-blur-sm rounded-2xl sm:rounded-3xl p-3 sm:p-4 md:p-6 border border-white/8 shadow-lg transition-transform duration-300 hover:-translate-y-2 hover:shadow-2xl">
              <div className="flex items-center justify-between">
                <h3 className="text-white font-bold text-sm sm:text-base md:text-lg">
                  Website Development
                </h3>
              </div>

              <ul className="text-white/90 mt-2 sm:mt-3 md:mt-4 space-y-1.5 sm:space-y-2 md:space-y-3">
                <li className="project-item">
                  <a
                    href="https://mazville.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-start gap-1.5 sm:gap-2 md:gap-3"
                  >
                    <span className="w-2 h-2 sm:w-2.5 sm:h-2.5 md:w-3 md:h-3 bg-emerald-400 rounded-full mt-1 sm:mt-1.5 md:mt-2 shrink-0" />
                    <span className="project-name leading-tight text-xs sm:text-sm md:text-sm">Mazville</span>
                  </a>
                </li>
                <li className="project-item">
                  <a
                    href="https://aanpublishing.org"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-start gap-1.5 sm:gap-2 md:gap-3"
                  >
                    <span className="w-2 h-2 sm:w-2.5 sm:h-2.5 md:w-3 md:h-3 bg-emerald-400 rounded-full mt-1 sm:mt-1.5 md:mt-2 shrink-0" />
                    <span className="project-name leading-tight text-xs sm:text-sm md:text-sm">
                      AAN Publications
                    </span>
                  </a>
                </li>
                <li className="project-item">
                  <a
                    href="https://lextria.in"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-start gap-1.5 sm:gap-2 md:gap-3"
                  >
                    <span className="w-2 h-2 sm:w-2.5 sm:h-2.5 md:w-3 md:h-3 bg-emerald-400 rounded-full mt-1 sm:mt-1.5 md:mt-2 shrink-0" />
                    <span className="project-name leading-tight text-xs sm:text-sm md:text-sm">Lextria</span>
                  </a>
                </li>
              </ul>
            </div>

            <div className="card-accent backdrop-blur-sm rounded-2xl sm:rounded-3xl p-3 sm:p-4 md:p-6 border border-white/8 shadow-lg transition-transform duration-300 hover:-translate-y-2 hover:shadow-2xl">
              <div className="flex items-center justify-between">
                <h3 className="text-white font-bold text-xs sm:text-sm md:text-lg">
                  Product Development
                </h3>
              </div>

              <ul className="text-white/90 mt-2 sm:mt-3 md:mt-4 space-y-1.5 sm:space-y-2 md:space-y-3">
                <li className="project-item">
                  <a
                    href="https://certgen.org"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-start gap-1.5 sm:gap-2 md:gap-3"
                  >
                    <span className="w-2 h-2 sm:w-2.5 sm:h-2.5 md:w-3 md:h-3 bg-sky-400 rounded-full mt-1 sm:mt-1.5 md:mt-2 shrink-0" />
                    <span className="project-name leading-tight text-xs sm:text-sm md:text-sm">CertGen</span>
                  </a>
                </li>
                <li className="project-item flex items-start gap-1.5 sm:gap-2 md:gap-3">
                  <span className="w-2 h-2 sm:w-2.5 sm:h-2.5 md:w-3 md:h-3 bg-sky-400 rounded-full mt-1 sm:mt-1.5 md:mt-2 shrink-0" />
                  <span className="project-name leading-tight text-xs sm:text-sm md:text-sm">Auto IP</span>
                </li>
                <li className="project-item flex items-start gap-1.5 sm:gap-2 md:gap-3">
                  <span className="w-2 h-2 sm:w-2.5 sm:h-2.5 md:w-3 md:h-3 bg-sky-400 rounded-full mt-1 sm:mt-1.5 md:mt-2 shrink-0" />
                  <span className="project-name leading-tight text-xs sm:text-sm md:text-sm">IDF</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
